import type { SignUpInput } from "@/lib/definitions";

interface ApiErrorPayload {
  message?: string;
  errors?: Record<string, string[]>;
}

export class ApiError extends Error {
  errors?: Record<string, string[]>;

  constructor(message: string, errors?: Record<string, string[]>) {
    super(message);
    this.name = "ApiError";
    this.errors = errors;
  }
}

async function parseResponseBody(response: Response): Promise<ApiErrorPayload> {
  const text = await response.text();

  if (!text) {
    return {};
  }

  try {
    return JSON.parse(text) as ApiErrorPayload;
  } catch {
    return { message: text };
  }
}

async function apiRequest<T>(
  path: string,
  options?: RequestInit
): Promise<T> {
  const response = await fetch(path, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options?.headers ?? {}),
    },
  });

  const body = await parseResponseBody(response);

  if (!response.ok) {
    throw new ApiError(
      body.message ?? `Request failed with status ${response.status}.`,
      body.errors
    );
  }

  return body as T;
}

export async function register(values: SignUpInput) {
  return apiRequest<{ success: true }>("/api/v1/auth/signup", {
    method: "POST",
    body: JSON.stringify(values),
  });
}
